"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.onloginUserSwitch = onloginUserSwitch;
exports["default"] = void 0;

function onloginUserSwitch(callback) {
  var _window, _window$browser, _window$browser$event;

  if ((_window = window) !== null && _window !== void 0 && (_window$browser = _window.browser) !== null && _window$browser !== void 0 && (_window$browser$event = _window$browser.event) !== null && _window$browser$event !== void 0 && _window$browser$event.onloginUserSwitch) {
    var _window2, _window2$browser, _window2$browser$even;

    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$browser = _window2.browser) === null || _window2$browser === void 0 ? void 0 : (_window2$browser$even = _window2$browser.event) === null || _window2$browser$even === void 0 ? void 0 : _window2$browser$even.onloginUserSwitch(callback !== null && callback !== void 0 ? callback : function () {});
  }

  throw Error("onloginUserSwitch error: no match jsapi");
}

var _default = {
  onloginUserSwitch: onloginUserSwitch
};
exports["default"] = _default;